<body class="deleteUserModel">
  <button class="close-btn closeDeleteUserModel" (click)="openCloseDeleteUserModal()">Close</button>
  <h1 class="modal-title text-center">Confirm Delete</h1>

  <div class="userInfo">
    @if (userModel(); as u) {
      <h4>Name: {{ u.displayName }}</h4>
      <h4>Email: {{ u.email }}</h4>
      <h4>Phone: {{ u.phone }}</h4>
    }
  </div>

  <button class="btn btn-yellow w-132 deleteUser" (click)="deleteUser()">Delete User</button>
  <button class="btn btn-yellow w-132 cancelDeleteUser" (click)="openCloseDeleteUserModal()">
    Cancel
  </button>
</body>
